<div class="page-container">
  <app-nav></app-nav>

  <main class="main-content">
    <div class="content-wrapper">

      <header class="page-header">
        <h1 class="page-title">Visualizar Órdenes</h1>
      </header>

      <div class="filter-card">
        <div class="filter-grid">
          <label class="filter-group">
            <span class="label-text">Nombre Operario</span>
            <div class="input-wrapper">
              <span class="material-symbols-outlined input-icon">search</span>
              <input type="text" class="form-input" placeholder="Buscar técnico..." [(ngModel)]="filtroOperario"
                list="operariosFilterList" (change)="aplicarFiltros()" (keyup.enter)="aplicarFiltros()" />
              <datalist id="operariosFilterList">
                <option *ngFor="let op of listaOperarios" [value]="op.nombre"></option>
              </datalist>
            </div>
          </label>

          <label class="filter-group">
            <span class="label-text">Fecha</span>
            <div class="input-wrapper">
              <span class="material-symbols-outlined input-icon">calendar_today</span>
              <input type="date" class="form-input" [(ngModel)]="filtroFecha" />
            </div>
          </label>

          <div class="filter-actions">
            <button class="btn btn-primary" (click)="aplicarFiltros()">Aplicar</button>
            <button class="btn btn-secondary" (click)="limpiarFiltros()">Limpiar</button>
          </div>
        </div>
      </div>

      <div class="table-card">
        <div class="table-responsive">
          <table class="orders-table">
            <thead>
              <tr>
                <th>No. Orden</th>
                <th>Nombre Cliente</th>
                <th>Servicio Principal</th>
                <th>Valor Total</th>
                <th>Operario</th>
                <th>Fecha</th>
                <th>Estado</th>
                <th class="text-center">Acciones</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let orden of ordenesPaginadas">
                <td class="font-medium">{{ orden.numero }}</td>
                <td>{{ orden.cliente }}</td>
                <td>{{ orden.servicioPrincipal }}</td>
                <td style="white-space: nowrap;">$ {{ orden.valorTotal | number }}</td>
                <td>{{ orden.operario }}</td>
                <td class="fecha-col">{{ orden.fecha }}</td>
                <td>
                  <select class="estado-select-native"
                    [disabled]="orden.estado === 'Orden finalizada' || !puedeModificarOrden(orden)"
                    [(ngModel)]="orden.estado"
                    (change)="verificarCambioEstado(orden)">
                    <option value="Proceso">En proceso</option>
                    <option value="Lista">Orden lista</option>
                    <option value="Orden finalizada">Orden finalizada</option>
                    <option value="Cancelada">Cancelada</option>
                  </select>
                </td>
                <td>
                  <div class="action-buttons">
                    <button class="btn-icon" title="Ver Detalles" (click)="abrirModalVer(orden)">
                      <span class="material-symbols-outlined">visibility</span>
                    </button>
                    <ng-container *ngIf="orden.estado !== 'Orden finalizada'">
                      <button class="btn-icon" title="Editar" *ngIf="puedeModificarOrden(orden)" (click)="abrirModalEditar(orden)">
                        <span class="material-symbols-outlined">edit</span>
                      </button>
                      <button class="btn-icon delete" title="Eliminar" *ngIf="puedeModificarOrden(orden)" (click)="eliminarOrden(orden)">
                        <span class="material-symbols-outlined">delete</span>
                      </button>
                    </ng-container>
                  </div>
                </td>
              </tr>
              <tr *ngIf="ordenesFiltradas.length === 0">
                <td colspan="8" class="text-center" style="padding: 2rem; color: #9ca3af;">
                  No se encontraron órdenes con esos filtros.
                </td>
              </tr>
            </tbody>
          </table>

          <div class="pagination-controls" *ngIf="totalItems > itemsPorPagina">
            <button class="btn-page" (click)="cambiarPagina(paginaActual - 1)" [disabled]="paginaActual === 1">
              <span class="material-symbols-outlined">chevron_left</span>
            </button>
            <span class="page-info">
              Página {{ paginaActual }} de {{ totalPaginas }} ({{ totalItems }} registros)
            </span>
            <button class="btn-page" (click)="cambiarPagina(paginaActual + 1)" [disabled]="paginaActual === totalPaginas">
              <span class="material-symbols-outlined">chevron_right</span>
            </button>
          </div>
        </div>
      </div>

      <div class="total-summary-card" *ngIf="mostrarTotal">
        <div class="summary-container" style="justify-content: flex-end; gap: 2rem;">
          <div class="total-wrapper">
            <label class="total-label">Total {{ filtroOperario ? (filtroOperario | titlecase) : 'Filtrado' }}:</label>
            <div class="input-wrapper-simple">
              <input type="text" class="total-input" [value]="'$ ' + (totalFiltrado | number)" readonly />
            </div>
          </div>
          <div class="total-wrapper">
            <label class="total-label" style="color:#00e676">Efectivo:</label>
            <div class="input-wrapper-simple">
              <input type="text" class="total-input" [value]="'$ ' + (totalEfectivoFiltrado | number)" readonly />
            </div>
          </div>
          <div class="total-wrapper">
            <label class="total-label" style="color:#2196f3">Transferencia:</label>
            <div class="input-wrapper-simple">
              <input type="text" class="total-input" [value]="'$ ' + (totalTransferenciaFiltrado | number)" readonly />
            </div>
          </div>
          <div class="total-wrapper">
            <label class="total-label">Pago Operario (40%):</label>
            <div class="input-wrapper-simple">
              <input type="text" class="total-input pago-resaltado" [value]="'$ ' + (pagoOperarioFiltrado | number)" readonly />
            </div>
          </div>
        </div>
      </div>

    </div>
  </main>

  <!-- ==================== MODAL VER / EDITAR ORDEN ==================== -->
  <div class="modal-overlay" *ngIf="mostrarModal">
    <div class="modal-content-large">
      <div class="modal-header">
        <h2>{{ modoEdicion ? 'Editar Orden' : 'Detalles de Orden' }}
          <span class="text-primary">{{ ordenSeleccionada.numero }}</span>
        </h2>
        <button class="btn-close" (click)="cerrarModal()">
          <span class="material-symbols-outlined">close</span>
        </button>
      </div>

      <div class="modal-body scrollable">

        <!-- Datos del Cliente -->
        <h3 class="section-subtitle">Datos del Cliente y Orden</h3>
        <div class="modal-grid">
          <div class="form-group">
            <label>Fecha</label>
            <input type="date" [(ngModel)]="ordenSeleccionada.fecha" [readonly]="!modoEdicion" class="input-dark">
          </div>
          <div class="form-group">
            <label>Hora</label>
            <input type="time" [(ngModel)]="ordenSeleccionada.hora" [readonly]="!modoEdicion" class="input-dark">
          </div>
          <div class="form-group">
            <label>Nombre Cliente</label>
            <input type="text" [(ngModel)]="ordenSeleccionada.cliente" [readonly]="!modoEdicion" class="input-dark">
          </div>
          <div class="form-group">
            <label>Celular</label>
            <input type="text" [(ngModel)]="ordenSeleccionada.celular" [readonly]="!modoEdicion" class="input-dark">
          </div>
          <div class="form-group full-width">
            <label>Notas / Observaciones</label>
            <textarea [(ngModel)]="ordenSeleccionada.notas" [readonly]="!modoEdicion" class="input-dark" rows="3"
              placeholder="Sin observaciones"></textarea>
          </div>
        </div>

        <!-- Información del Vehículo -->
        <h3 class="section-subtitle mt-4">Información del Vehículo</h3>
        <div class="modal-grid">
          <div class="form-group">
            <label>Marca</label>
            <input type="text" [(ngModel)]="ordenSeleccionada.vehiculoMarca" [readonly]="!modoEdicion" class="input-dark">
          </div>
          <div class="form-group">
            <label>Modelo</label>
            <input type="text" [(ngModel)]="ordenSeleccionada.vehiculoModelo" [readonly]="!modoEdicion" class="input-dark">
          </div>
          <div class="form-group">
            <label>Placa</label>
            <input type="text" [(ngModel)]="ordenSeleccionada.vehiculoPlaca" [readonly]="!modoEdicion" class="input-dark">
          </div>
          <div class="form-group">
            <label>Tipo</label>
            <select [(ngModel)]="ordenSeleccionada.vehiculoTipo" [disabled]="!modoEdicion" class="input-dark">
              <option value="automovil">Automóvil</option>
              <option value="campero">Campero</option>
              <option value="camioneta">Camioneta</option>
              <option value="moto">Moto</option>
              <option value="otro">Otro</option>
            </select>
          </div>
        </div>

        <!-- Casco (solo si es moto) -->
        <div class="modal-grid" *ngIf="ordenSeleccionada.vehiculoTipo === 'moto'">
          <div class="form-group">
            <label>¿Dejó casco?</label>
            <select [(ngModel)]="ordenSeleccionada.dejoCasco" [disabled]="!modoEdicion" class="input-dark">
              <option [ngValue]="true">Sí</option>
              <option [ngValue]="false">No</option>
            </select>
          </div>
          <div class="form-group" *ngIf="ordenSeleccionada.dejoCasco">
            <label>¿Cuántos cascos dejó?</label>
            <input type="number" min="1" [(ngModel)]="ordenSeleccionada.cantidadCascos"
              [readonly]="!modoEdicion" class="input-dark">
          </div>
        </div>

        <!-- Servicios -->
        <h3 class="section-subtitle mt-4">Detalles y Pago</h3>
        <div class="services-list-box">
          <div class="header-services"
            style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 0.5rem;">
            <p class="label-text" style="margin: 0;">Servicios Incluidos:</p>

            <!-- Agregar servicio (solo en edición) -->
            <div *ngIf="modoEdicion" class="add-service-container"
              style="display: flex; gap: 0.5rem; align-items: center;">
              <select [(ngModel)]="servicioSeleccionadoParaAgregar" class="input-dark"
                style="padding: 0.4rem; min-width: 200px;">
                <option [ngValue]="null" disabled selected>Seleccionar servicio/combo</option>
                <option *ngFor="let serv of serviciosDisponiblesParaVehiculo" [ngValue]="serv">
                  {{ serv.nombre }} - $ {{ serv.precio | number }}
                </option>
                <option [ngValue]="'ADICIONAL'">Adicional</option>
              </select>
              <button class="btn btn-primary" (click)="agregarServicio()"
                [disabled]="!servicioSeleccionadoParaAgregar"
                style="min-width: 40px; padding: 0 0.5rem;">
                <span class="material-symbols-outlined" style="font-size: 1.2rem;">add</span>
              </button>
            </div>
          </div>

          <!-- Lista de servicios -->
          <ul *ngIf="ordenSeleccionada.serviciosDetallados && ordenSeleccionada.serviciosDetallados.length > 0; else noServicios"
            style="list-style: none; padding: 0; margin: 0; display: flex; flex-direction: column; gap: 0.4rem;">
            <li *ngFor="let item of ordenSeleccionada.serviciosDetallados; let i = index"
              style="display: flex; justify-content: space-between; align-items: center; background-color: #333; padding: 0.5rem 1rem; border-radius: 6px;">
              <span style="flex: 1;">
                {{ item.servicio || item.nombre }}
                <span class="text-muted" style="font-size: 0.8em; margin-left: 0.5rem;">
                  (x{{ item.cantidad || 1 }}) - $ {{ (item.precio || item.valor || 0) | number }}
                </span>
              </span>
              <button *ngIf="modoEdicion" (click)="eliminarServicio(i)"
                style="background: none; border: none; color: #ff4d4d; cursor: pointer; display: flex; align-items: center; padding: 2px;">
                <span class="material-symbols-outlined" style="font-size: 1.2rem;">delete</span>
              </button>
            </li>
          </ul>

          <ng-template #noServicios>
            <p class="text-muted" style="font-style: italic; padding: 0.5rem;">No hay servicios registrados.</p>
          </ng-template>
        </div>

        <!-- Operario, Método de Pago, Total -->
        <div class="modal-grid mt-2">
          <div class="form-group">
            <label>Operario Asignado</label>
            <select [(ngModel)]="ordenSeleccionada.id_operario" [disabled]="!modoEdicion" class="input-dark">
              <option [ngValue]="null">Sin asignar</option>
              <option *ngFor="let op of listaOperarios" [ngValue]="op.id_user">
                {{ op.nombre }}
              </option>
            </select>
          </div>
          <div class="form-group">
            <label>Método de Pago</label>
            <select [(ngModel)]="ordenSeleccionada.metodoPago" [disabled]="!modoEdicion" class="input-dark">
              <option *ngFor="let metodo of metodospagoDisponibles" [value]="metodo.nombre">
                {{ metodo.nombre }}
              </option>
            </select>
          </div>
          <div class="form-group">
            <label>Valor Total</label>
            <div class="price-display">$ {{ ordenSeleccionada.valorTotal | number }}</div>
          </div>
        </div>

      </div>

      <div class="modal-footer">
        <button class="btn btn-secondary" (click)="cerrarModal()">{{ modoEdicion ? 'Cancelar' : 'Cerrar' }}</button>
        <button class="btn btn-primary" *ngIf="modoEdicion" (click)="guardarCambios()">Guardar Cambios</button>
      </div>
    </div>
  </div>

  <!-- ==================== MODAL ADICIONAL ==================== -->
  <div class="modal-overlay" *ngIf="mostrarModalAdicional">
    <div class="modal-content" style="max-width: 400px; padding: 2.5rem;">
      <div class="modal-header">
        <h2>Agregar Servicio Adicional</h2>
        <button class="btn-close" (click)="cerrarModalAdicional()">
          <span class="material-symbols-outlined">close</span>
        </button>
      </div>
      <div class="modal-body" style="display: flex; flex-direction: column; gap: 1rem; padding: 1rem 0;">
        <div class="form-group">
          <label>Descripción del adicional</label>
          <input type="text" [(ngModel)]="descAdicional" class="input-dark" placeholder="Ej: Limpieza de tapetes extra">
        </div>
        <div class="form-group">
          <label>Valor ($)</label>
          <input type="number" [(ngModel)]="valorAdicional" class="input-dark" placeholder="Ej: 15000" min="0">
        </div>
      </div>
      <div class="modal-footer">
        <button class="btn btn-secondary" (click)="cerrarModalAdicional()">Cancelar</button>
        <button class="btn btn-primary" (click)="confirmarAdicional()">Agregar</button>
      </div>
    </div>
  </div>

  <!-- ==================== MODAL FACTURA ==================== -->
  <div class="modal-overlay" *ngIf="mostrarFactura">
    <div class="factura-modal">

      <div class="factura-header">
        <div class="header-left">
          <img src="assets/logo.jpeg" alt="Logo The Detailer" class="factura-logo" loading="lazy" />
        </div>
        <div class="header-right">
          <p class="factura-title">Factura de Venta</p>
        </div>
      </div>

      <div class="factura-company-info">
        <div class="info-content">
          <p class="info-bold">NIT 100002212-9</p>
          <p class="info-muted">Crr 18 #2-13 Armenia Q.</p>
          <p class="info-muted">3127736569</p>
        </div>
      </div>

      <div class="factura-body scrollable">
        <h3 class="section-heading">Datos Generales</h3>
        <div class="data-grid">
          <div class="data-item">
            <p class="label">Orden ID</p>
            <p class="value">{{ ordenSeleccionada.numero }}</p>
          </div>
          <div class="data-item">
            <p class="label">Fecha</p>
            <p class="value">{{ ordenSeleccionada.fecha }}</p>
          </div>
          <div class="data-item">
            <p class="label">Cliente</p>
            <p class="value">{{ ordenSeleccionada.cliente }}</p>
          </div>
          <div class="data-item">
            <p class="label">Celular</p>
            <p class="value">{{ ordenSeleccionada.celular }}</p>
          </div>
        </div>

        <div class="factura-table-container">
          <div class="table-border">
            <table class="factura-table">
              <thead>
                <tr>
                  <th>Producto / Servicio</th>
                  <th class="text-right">Cantidad</th>
                  <th class="text-right">Valor Unitario</th>
                  <th class="text-right">Subtotal</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of ordenSeleccionada.serviciosDetallados">
                  <td>{{ item.servicio || item.nombre }}</td>
                  <td class="text-right">{{ item.cantidad || 1 }}</td>
                  <td class="text-right">$ {{ (item.precio_unitario || item.precio || item.valor || 0) | number }}</td>
                  <td class="text-right">$ {{ (item.subtotal || ((item.cantidad || 1) * (item.precio_unitario || item.precio || 0))) | number }}</td>
                </tr>
                <tr *ngIf="!ordenSeleccionada.serviciosDetallados || ordenSeleccionada.serviciosDetallados.length === 0">
                  <td colspan="4" class="text-center">Sin detalles de servicios</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="factura-totals">
          <div class="totals-box">
            <div class="total-row border-top">
              <p class="value-bold">Total a Pagar</p>
              <p class="value-bold">$ {{ ordenSeleccionada.valorTotal | number }}</p>
            </div>
            <div class="total-row row-metodo-pago">
              <p class="label" style="color: white; font-weight: bold;">Forma de Pago:</p>
              <select [(ngModel)]="ordenSeleccionada.metodoPago" class="input-dark select-pago-factura"
                (change)="resetCalculadora()">
                <option *ngFor="let metodo of metodospagoDisponibles" [value]="metodo.nombre">
                  {{ metodo.nombre }}
                </option>
              </select>
            </div>
          </div>
        </div>

        <!-- Calculadora de vueltos -->
        <div class="change-calculator-section mt-4" *ngIf="ordenSeleccionada.metodoPago === 'Efectivo'">
          <div class="form-group full-width">
            <label style="color: #10b981; font-weight: bold;">Monto Recibido en Efectivo ($)</label>
            <input type="number" class="input-dark input-lg text-right" placeholder="Ej: 50000"
              [(ngModel)]="montoRecibido" min="0">
          </div>
          <div class="quick-cash-buttons mt-2">
            <button class="btn-cash" (click)="setMontoRecibido(20000)">$20k</button>
            <button class="btn-cash" (click)="setMontoRecibido(50000)">$50k</button>
            <button class="btn-cash" (click)="setMontoRecibido(100000)">$100k</button>
            <button class="btn-cash exacto" (click)="setMontoRecibido(ordenSeleccionada.valorTotal)">Exacto</button>
          </div>
          <div class="change-display mt-3"
            [ngClass]="{'insufficient': (montoRecibido || 0) > 0 && cambioDevolver < 0}">
            <span>Devuelve:</span>
            <span class="change-amount" *ngIf="(montoRecibido || 0) >= ordenSeleccionada.valorTotal">
              $ {{ cambioDevolver | number }}
            </span>
            <span class="change-amount error" *ngIf="(montoRecibido || 0) > 0 && cambioDevolver < 0">
              Faltan $ {{ (cambioDevolver * -1) | number }}
            </span>
            <span class="change-amount" *ngIf="!(montoRecibido || 0)">$ 0</span>
          </div>
        </div>

        <!-- Sección Rifa -->
        <div class="rifa-section">
          <div class="rifa-status">
            <span class="rifa-status-badge" [class.active]="rifaActiva" [class.inactive]="!rifaActiva">
              {{ rifaActiva ? '🎯 Rifa Activa' : '⚠️ Sin Rifa' }}
            </span>
            <span class="rifa-info" *ngIf="rifaActiva">
              Juega: {{ formatearFechaRifa(datosRifaActiva.fecha_sorteo) }}
            </span>
          </div>
          <p class="rifa-question">¿Desea agregar la rifa?</p>
          <div class="rifa-buttons">
            <button
              class="btn-rifa-yes"
              [class.selected]="opcionRifaSeleccionada === true"
              [disabled]="!rifaActiva"
              [title]="rifaActiva ? 'Aceptar rifa' : 'No hay rifa activa en este momento'"
              (click)="aceptarRifa()">
              Sí
            </button>
            <button
              class="btn-rifa-no"
              [class.selected]="opcionRifaSeleccionada === false"
              (click)="rechazarRifa()">
              No
            </button>
          </div>
        </div>

        <div class="boleta-container" *ngIf="mostrarRifa">
          <h2 class="boleta-title">Boleta de Rifa</h2>
          <div class="boleta-grid">
            <div class="boleta-form">
              <h3 class="section-heading-sm">Campos del participante</h3>
              <div class="form-stack">
                <div class="input-group">
                  <label for="rifa-nombre">Nombre</label>
                  <input id="rifa-nombre" type="text" [(ngModel)]="ordenSeleccionada.cliente" class="input-rifa" />
                </div>
                <div class="input-group">
                  <label for="rifa-celular">Celular</label>
                  <input id="rifa-celular" type="tel" [(ngModel)]="ordenSeleccionada.celular" class="input-rifa" />
                </div>
                <div class="input-group">
                  <label for="rifa-placa">Placa del vehículo</label>
                  <input id="rifa-placa" type="text" [(ngModel)]="ordenSeleccionada.vehiculoPlaca" class="input-rifa" />
                </div>
              </div>
            </div>

            <div class="boleta-card">
              <div class="boleta-card-header">
                <img src="assets/logo.jpeg" alt="Logo" class="boleta-logo" loading="lazy" />
                <div>
                  <p class="boleta-date">Juega el {{ formatearFechaRifa(datosRifaActiva.fecha_sorteo) }}</p>
                </div>
              </div>
              <div class="boleta-card-body">
                <p class="boleta-prize">Premios:</p>
                <div class="boleta-list" style="white-space: pre-wrap;">{{ datosRifaActiva.descripcion_premios }}</div>
                <div class="input-group mt-2">
                  <label>Seleccionar Número de Boleta</label>
                  <div class="search-rifa-bar">
                    <span class="material-symbols-outlined">search</span>
                    <input type="text" placeholder="Buscar número..." [(ngModel)]="filtroRifa"
                      (keyup)="aplicarFiltroRifa()" />
                  </div>
                  <div class="grid-numeros-rifa">
                    <div class="numero-item" *ngFor="let item of numerosRifaFiltrados"
                      [class.ocupado]="item.estado === 'ocupado'"
                      [class.seleccionado]="item.estado === 'seleccionado'"
                      (click)="seleccionarNumeroRifa(item)"
                      [title]="item.ocupadoPor ? 'Ocupado por: ' + item.ocupadoPor : 'Disponible'">
                      {{ item.valor }}
                    </div>
                  </div>
                  <div class="seleccion-info" *ngIf="numeroBoletaRifa">
                    Número seleccionado: <strong>{{ numeroBoletaRifa }}</strong>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="boleta-footer">
            <p>Responsable: {{ datosRifaActiva.encargado }}. Cel: 3127736569. Caducidad: 30 días. Aplica únicamente
              para el vehículo registrado.</p>
          </div>
        </div>

        <!-- Preferencia de recibo -->
        <div style="margin-top: 2rem; background: rgba(255,255,255,0.03); padding: 1rem; border-radius: 8px; border: 1px solid var(--border-color);">
          <label style="margin-bottom: 0.5rem; color: white; display:block; font-weight: 600;">¿Cómo desea enviar el recibo?</label>
          <div style="display: flex; gap: 1.5rem; flex-wrap: wrap; margin-top: 0.5rem;">
            <label style="display: flex; align-items: center; gap: 0.5rem; cursor: pointer;">
              <input type="checkbox" [checked]="preferenciaRecibo.includes('SMS')"
                (change)="onPreferenciaReciboChange('SMS', $event)"
                style="accent-color: #fd0100; width: 1.2rem; height: 1.2rem;">
              📱 SMS (Link de descarga)
            </label>
            <label style="display: flex; align-items: center; gap: 0.5rem; cursor: pointer;">
              <input type="checkbox" [checked]="preferenciaRecibo.includes('FISICO')"
                (change)="onPreferenciaReciboChange('FISICO', $event)"
                style="accent-color: #fd0100; width: 1.2rem; height: 1.2rem;">
              🖨️ Físico (Impresora)
            </label>
          </div>
          <p style="font-size: 0.85rem; color: #9ca3af; margin-top: 0.75rem;">
            💡 SMS: Recibimos tu teléfono y te enviamos un link para descargar tu recibo en PDF.
          </p>
        </div>

      </div>

      <div class="factura-actions">
        <button
          class="btn-send"
          [disabled]="!rifaSeleccionada || (ordenSeleccionada.metodoPago === 'Efectivo' && ((montoRecibido || 0) < ordenSeleccionada.valorTotal))"
          [title]="!rifaSeleccionada ? 'Selecciona Sí o No para la rifa primero' : 'Completar la orden'"
          (click)="enviarFactura()">
          Completar Orden
        </button>
        <button class="btn-cancel-factura" (click)="cerrarFactura()">Cancelar</button>
      </div>

    </div>
  </div>

</div>